import { parsePhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';
import { SYMBOLS_REGEX } from './Validations';

export const PASSWORD_VALIDATIONS = z
  .string({ required_error: 'Password is required' })
  .trim()
  .min(12, {
    message: 'Password must have a minimum of 12 characters',
  })
  .max(128, {
    message: 'Password cannot be more than 128 characters',
  })
  .refine((val) => !/\s/.test(val), {
    message: 'Password cannot contain any spaces',
  })
  .refine((val) => /[a-z]/.test(val), {
    message: 'Password must contain at least: 1 lower-case character',
  })
  .refine((val) => /[A-Z]/.test(val), {
    message: 'Password must contain at least: 1 upper-case character',
  })
  .refine((val) => /[0-9]/.test(val), {
    message: 'Password must contain at least: 1 digit',
  })
  .refine((val) => SYMBOLS_REGEX.test(val), {
    message: 'Password must contain at least: 1 symbol',
  });

export const PHONE_NUMBER_VALIDATIONS = z
  .string({
    required_error: 'Please enter phone number',
  })
  .trim()
  .min(1, { message: 'Please enter phone number' })
  .refine(
    async (phone) => {
      if (!phone) return false;

      try {
        const isValidPhoneNumber = await parsePhoneNumber(
          `+1${phone}`,
        )?.isValid();
        return isValidPhoneNumber;
      } catch (e) {
        return false;
      }
    },
    {
      message: 'Please enter a valid phone number',
    },
  );
